module.exports = __webpack_public_path__ + "static/media/jackpot-bg.5d91040e.gif";